<template>
  <img
    v-if="srcset"
    :data-srcset="srcset"
    :data-src="src"
    :alt="alt"
    class="ImgLazy"
  >

  <img
    v-else
    :data-src="src"
    :alt="alt"
    class="ImgLazy"
  >
</template>

<script>
import lozad from 'lozad';

export default {
  name: 'ImgLazy',
  props: {
    srcset: {
      type: String,
      default: null
    },
    src: {
      type: String,
      default: null
    },
    alt: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      loading: true
    };
  },
  mounted() {
    const setLoadingState = () => {
      this.loading = false;
    };
    this.$el.addEventListener('load', setLoadingState);
    this.$once('hook:destroyed', () => {
      this.$el.removeEventListener('load', setLoadingState);
    });

    const observer = lozad(this.$el);
    observer.observe();
  }
};
</script>

<style lang="scss">
// Responsive image styles.
.ImgLazy {
  max-width: 100%;
  max-height: 100%;
  width: auto;
  height: auto;
  vertical-align: middle;
}
</style>
